import { render } from "./PlayButton.vue?vue&type=template&id=2defa0c0&scoped=true"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"

import "./PlayButton.vue?vue&type=style&index=0&id=2defa0c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2defa0c0"]])

export default __exports__